export default "__VITE_ASSET__AMTC2Pt2__"